import React, { useCallback } from "react";
import { useVelavuToast } from "../elements/velavu-toast";
import { VelavuAPI, NotFoundError, VelavuDevice } from "velavu-js-api";
import { ToastNotificationNoContent } from "../elements/toast-notification-builtins";
import { useProvideContentRefreshable } from "../elements/refresh-context";

/// Registers a device state to be refreshable
export function useProvideDeviceStateRefreshable(
	device: VelavuDevice | undefined,
	setDevice: (device: VelavuDevice | undefined) => void,
) {
	const { pushToast } = useVelavuToast();

	const refresh = useCallback(async () => {
		//Ignore if there is no device
		if (device === undefined) {
			return;
		}

		//Load the device
		let updatedDevice: VelavuDevice;
		try {
			updatedDevice = await VelavuAPI.devices.getSpecificDevice(
				device.id,
			);
		} catch (err) {
			if (err instanceof NotFoundError) {
				setDevice(undefined);
				pushToast((close) => (
					<ToastNotificationNoContent onDismiss={close} />
				));
				return;
			} else {
				//Propagate other errors
				throw err;
			}
		}

		setDevice(updatedDevice);
	}, [device, setDevice]);

	useProvideContentRefreshable(refresh);
}
